/** ABC analysis calculation criteria */
export enum AbcAnalysisByEnum {
  BY_DATE = 'BY_DATE',
  BY_CREATOR = 'BY_CREATOR',
  BY_COMPANY = 'BY_COMPANY',
  BY_CONTRAGENT = 'BY_CONTRAGENT',
  BY_DOCUMENT_TYPE = 'BY_DOCUMENT_TYPE',
  BY_OPERATION_TYPE = 'BY_OPERATION_TYPE',
  BY_FILIAL = 'BY_FILIAL',
  BY_DIRECTION = 'BY_DIRECTION',
  BY_UNIT = 'BY_UNIT',
  BY_DEAL = 'BY_DEAL',
  BY_CONTRACT = 'BY_CONTRACT',
  BY_COST_CENTER = 'BY_COST_CENTER',
}
